// extracted by mini-css-extract-plugin
module.exports =  {"resetMargin":"resetMargin__CDfUs"};